var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimilarQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/Chatbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 3.50015V16.5007C24 18.4308 22.4299 20.0008 20.4999 20.0008H16.9677L12.9825 23.296C12.7075 23.541 12.3565 23.664 12.0045 23.664C11.6485 23.664 11.2885 23.538 11.0035 23.285L7.1053 20.0008H3.50015C1.57007 20.0008 4.77462e-07 18.4308 4.77462e-07 16.5007V3.50015C-0.000999564 1.57007 1.56907 0 3.49915 0H20.4999C22.4299 0 24 1.57007 24 3.50015ZM23 3.50015C23 2.12209 21.8789 1.00004 20.4999 1.00004H3.49915C2.12009 1.00004 0.999042 2.12209 0.999042 3.50015V16.5007C0.999042 17.8787 2.12009 19.0008 3.49915 19.0008H7.2873C7.40531 19.0008 7.51931 19.0428 7.60932 19.1188L11.6575 22.5289C11.8565 22.7069 12.1425 22.7049 12.3315 22.5369L16.4697 19.1158C16.5597 19.0418 16.6717 19.0008 16.7877 19.0008H20.4999C21.8789 19.0008 23 17.8787 23 16.5007V3.50015Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 8.63158C9 8.63158 9 6 11.6316 6C14.2632 6 15.5789 8.63158 14.2632 9.94737C12.9474 11.2632 11.1184 11.2632 11.6316 13.8947",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 11.6306,
    cy: 16.5261,
    r: 0.657895,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilarQuestionIcon);
export default __webpack_public_path__ + "static/media/similar-question-icon.aca2c1d3bec3614ad9d12e69bac375e5.svg";
export { ForwardRef as ReactComponent };